module.exports = __webpack_public_path__ + "img/seller.2b4b0d9b.jpeg";